import React, { useState, useEffect, useRef } from "react";
import { Grid, Modal } from 'react-bootstrap';
import {BiLoaderAlt} from 'react-icons/bi'
import TrackandTrace from '../../assets/img/track-trace-image.png';
import EsealLogo from '../../assets/img/eseal-black.png';
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import { applyThemeColors, getThemeColorsFromResponse } from '../../utilities/themeUtils';
import Select from 'react-select';
import { Redirect } from "react-router-dom";
import swal from 'sweetalert';
import { withTranslation } from 'react-i18next';
import i18n from "i18next";
import Cookies from 'universal-cookie';
import SimpleReactValidator from 'simple-react-validator';
import { PostAPI } from "api/post";
import BeatLoader from "react-spinners/BeatLoader";
import 'assets/css/custom.css';
import ButtonField from "components/UI/Button/ButtonField";

let urlhost = window.location.host;
let urlprotocol = window.location.protocol;
let completeURL = urlprotocol + "//" +urlhost;
const domain = urlhost.split('.');
const subDomain = domain[1] +"."+ domain[2];


const cookies = new Cookies();
const options = [
  { value: 'english', label: 'English', code: "en" },
  { value: 'chinese', label: 'Chinese', code: "chi" },
];

const Login = (props) => {
  const [state, setState] = useState({
    checked: false,
    checked1: false,
    showModal: false,
    showModal1: false,
    email: '',
    password: '',
    forgotEmail: '',
    errors: [],
    rememberMe: false,
    isDisabled: false,
    showHome: false,
    cookieCheck: null,
    loading: true,
    isLogin: false,
    selectedOption: localStorage.getItem('i18nextLng') || options[0]
  });

  const [dummy, setDummy] = useState(false);
  const validator = useRef(new SimpleReactValidator({
    element: (message, className) => (
      <p
        style={{
          color: 'red',
          fontSize: '14px',
          lineHeight: '1'
        }}
        className="text-danger"
      >
        {message}
      </p>
    )
  }));

  useEffect(() => {
    setState(prevState => ({ ...prevState, loading: false }));
    if (cookies.get('accessToken')) {
      hideLoader();
      props.history.push("/admin/home");
    }
    const cookieCheck = localStorage.getItem('cookieCheck') ? localStorage.getItem('cookieCheck') : null;
    setState(prevState => ({
      ...prevState,
      cookieCheck
    }));
    if (localStorage.getItem('rememberMe') === 'true' && localStorage.getItem('email') !== '') {
      setState(prevState => ({
        ...prevState,
        rememberMe: true,
        email: localStorage.getItem('email'),
        password: localStorage.getItem('password')
      }));
    }
  }, []);

  useEffect(() => {
    try {
      if (state.isLogin) {
        const isSidebarData = localStorage.getItem('newSidebar');
        if (isSidebarData && isSidebarData !== "undefined") {
          const isSidebarDataJson = JSON.parse(isSidebarData);
          if (isSidebarDataJson) {
            showLoader();
            props.history.push("/admin/home");
          }
        }
      }
    } catch (err) {
      swal(err, {
        icon: "warning",
        button: 'OK',
      });
    }
  }, [state.isLogin]);

  const handleChange = (event) => {
    const { name, type, checked, value } = event.target;
    setState(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleChangeCheckbox = () => {
    setState(prevState => {
      const newRememberMe = !prevState.rememberMe;
      localStorage.setItem('email', prevState.email);
      localStorage.setItem('password', prevState.password);
      localStorage.setItem('rememberMe', newRememberMe);
      return { ...prevState, rememberMe: newRememberMe };
    });
  };

  const hideLoader = () => setState(prevState => ({ ...prevState, loading: false }));

  const showLoader = () => setState(prevState => ({ ...prevState, loading: true }));
  const getAuthCode = async () => {
    const message = await swal({
      title: "Please enter authorization code",
      content: "input",
    });
    if (message != "" && message != null) {
      return message
    } 
  }

  const displayLogin = async (e) => {
    e.preventDefault();
    setState(prevState => ({
       ...prevState,
        isDisabled: true,
         loading: true
      }));
    let authCode;
    if (cookies.get("clientSubDomain") === "boat") {
        authCode = await getAuthCode()
    }

    const { email, password, rememberMe, cookieCheck, selectedOption } = state;
    localStorage.setItem('email', email);
    localStorage.setItem('password', password);
    localStorage.setItem('userLangauage', localStorage.getItem('i18nextLng') === 'en' ? 'english' : JSON.stringify(selectedOption));
    localStorage.setItem('rememberMe', rememberMe);
    if (cookieCheck !== null) localStorage.setItem('cookieCheck', cookieCheck);
    if (validator.current.allValid()) {
      const user = {
        email: email,
        password: password,
        language: selectedOption == null ? 'english' : selectedOption['value'],
        userOTP: authCode
      };     
      let url = `https://product-stg.${subDomain}:5004/login`;
      try {
        const res = await PostAPI(url, user);
        if (res.status === 200) {
          setState(prevState => ({ ...prevState, showHome: true }));
          cookies.set('accessToken', res.data.accessToken, { path: '/' });
          localStorage.setItem('newSidebar', JSON.stringify(res.data.featureYML));
          localStorage.setItem("wms",JSON.stringify(res.data.wms))
          localStorage.setItem('appManageUrls',JSON.stringify({
            desktopUrl: res.data.Desktopurl,
            mobileUrl: res.data.Mobileurl
          }));
          cookies.set('customer_type', res.data.customer_type, { path: '/' });
          cookies.set('customer_id', res.data.customer_id, { path: '/' });
          cookies.set('user_id', res.data.user_id, { path: '/' });
          cookies.set('userLocation_id', res.data.userLocation_id, { path: '/' });
          cookies.set('userRole_name', res.data.userRole_name, { path: '/' });

          const fields = ['name', 'title', 'path'];
          const formattedObject = res.data.featureYML.data.features.map((el) => {
            if (el.hasOwnProperty('submenuitem')) {
              el.submenuitem = el.submenuitem.map((item) => {
                // Create a new object with only the properties that exist in the `fields` array
                let filteredItem = {};
                for (let key in item) {
                  if (fields.includes(key)) {
                    filteredItem[key] = item[key];
                  }
                }
                return filteredItem;
              });
            }
            return el;
                  });
          const themeData = getThemeColorsFromResponse(res.data);
          applyThemeColors(themeData);

          if (res.data?.featureYML === undefined) {
            swal(res.data.message, {
              icon: "warning",
              button: 'OK',
            });
          } else {
            showLoader();
            setState(prevState => ({ 
              ...prevState,
               isLogin: true }));
          }
           // window.top.location.href="/admin/home";
            //window.open("/admin/home","_blank"); 
            //setTimeout(function(){document.location.href = "/admin/home";},250);
          // else if (res.status == 409) {
          //   swal({
          //     title: "Something went wrong!",
          //     text: "Please try again",
          //     icon: "error",
          //     timer: 2000,
          //     button: false
          //   })
          // }
        } else {
          setState(prevState => ({ ...prevState,
             isDisabled: false,
              loading: false 
            }
          ));
          hideLoader();
          swal({
            title: "Error!",
            text: res.message.response.data.error.message,
            icon: "error",
              //className: 'swal-footer-error',
              customClass: {
                // container: 'your-container-class',
                // popup: 'your-popup-class',
                // header: 'your-header-class',
                // title: 'your-title-class',
                // closeButton: 'your-close-button-class',
                // icon: 'your-icon-class',
                // image: 'your-image-class',
                content: 'swal-text',
                // input: 'your-input-class',
                // actions: 'your-actions-class',
                // confirmButton: 'your-confirm-button-class',
                // cancelButton: 'your-cancel-button-class',
                footer: 'swal-footer'
              }
              //timer: 2000,
              //button: false
          });
        }
      } catch (error) {
        // Handle error
      }
    } else {
      hideLoader();
      setState(prevState => ({ ...prevState, isDisabled: false, loading: false }));
      validator.current.showMessages();
      setDummy(!dummy);
    }
  };


  const open = () => {
    setState(prevState => ({ 
      ...prevState, 
      forgotEmail: prevState.email,
      showModal: true }));
  };

  const close = () => setState(prevState => ({ ...prevState, showModal: false }));
  const close1 = () => setState(prevState => ({ ...prevState, showModal1: false }));

  const submitForgot = async () => {
    let extraParameters = {url: completeURL};
    let data = { email: state.forgotEmail, extraParameters };
    let url = `https://login-stg.${subDomain}:3003/forgot-password/forgotpassword`;
    if (state.forgotEmail !== '') {
      if ((/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i).test(state.forgotEmail)) {
          try {
            const res = await PostAPI(url, data);
            if (res.status === 200) {
              if (res.data.data.status === 409) {
                swal({
                  title: "Invalid Email",
                  text: "Please enter valid email",
                  icon: "warning",
                  //timer: 2000,
                  button: true
                })
              }else {
              setState(prevState => ({ ...prevState, showModal: false }));
                swal({
                  title: "Email Sent",
                  text: "Reset password link has been sent to your mail",
                  icon: "success",
                  //timer: 2000,
                  button: true
                })
              }
            }else {
              swal({
                title: "Invalid Credentials!",
                icon: "error",
                timer: 2000,
                button: false
              })
            }
          } catch (error) {
            // Handle error
          }
      } else {
        swal({
          title: "Invalid Email",
          text: "Please enter valid email",
          icon: "warning",
          //timer: 2000,
          button: true
        });
      }
    } else {
      swal({
        title: "Email is Mandatory",
        text: "Please enter valid email",
        icon: "warning",
        button: true
      });
    }
  };

  return (
    <div className="login">
        <div className="login-container">
          <div className="left-panel">
            <div className="login-logo">
              <img src={EsealLogo} alt="eSeal Logo" />
            </div>
            <h2>Sign In</h2>
            <form className="login-form_fields" onSubmit={displayLogin}>
              <div className="form-fields">
                <div className="input-fields">
                  <i className="email fa fa-user" aria-hidden="true"></i>
                  <input
                    className={state.email ? 'not-empty' : ''}
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={state.email}
                    onChange={handleChange}
                  />
                </div>
                {validator.current.message('email', state.email, 'required|email')}
              </div>
              <div className="form-fields">
                <div className="input-fields">
                  <i className="password fa fa-lock" aria-hidden="true"></i>
                  <input
                    className={state.password ? 'not-empty' : ''}
                    type="password"
                    name="password"
                    placeholder="Password"
                    value={state.password}
                    onChange={handleChange}
                  />
                </div>
                {validator.current.message('password', state.password, 'required|min:6')}
              </div>
              <div className="cokkie-checks">
                <div>
                  <label>
                    <input
                      type="checkbox"
                      name="rememberMe"
                      checked={state.rememberMe}
                      onChange={handleChangeCheckbox}
                    />
                    Remember me
                  </label>
                </div>
                <div>
                  <label>
                    <input
                      type="checkbox"
                      name="cookieCheck"
                      checked={state.cookieCheck}
                      onChange={handleChange}
                    />
                    I am aware that this site will be using cookies to improve user experience by managing/retaining user sessions on the browser
                  </label>
                </div>
                {validator.current.message('cookieCheck', state.cookieCheck, 'required')}
              </div>
              <button type="submit" className={`login-button ${state.loading ? 'loading' : ''}`}   disabled={state.isDisabled}>
              {state.loading ? <BiLoaderAlt className="loader-icon" /> : 'Sign In'}
              </button>
              <div className="forgot-password">
                Forgot password?<a href="#" onClick={open}>&nbsp;Click here</a>
              </div>
            </form>
          </div>
          <div className="right-panel">
            <div className="track-trace-system">
              <p>
                <span>Track & Trace</span>
                <span>System</span>
              </p>
              <img src={TrackandTrace} alt="Track and Trace System" />
            </div>
          </div>
        </div>
      <Modal show={state.showModal} onHide={close}
      backdrop="static" keyboard={false}>
        <span className="close-icon-custom" onClick={close}>
                &times;
        </span>
        <Modal.Header key="MHeader" className="modal-header-custom">
          <Modal.Title>
            <div style={{color: "#FFFFFF"}} >
              Forgot Password
            </div>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ margin: '7px 16%' }}>
          <div className="forgotPassword-field">
            <input
              type="email"
              name="forgotEmail"
              placeholder="Email"
              value={state.forgotEmail}
              onChange={handleChange}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='footer-grid'  style={{ transform: 'translateY(20px)' }}>
            <div className='modal__button-container'>
              <button type='button' className='btnCls' onClick={submitForgot}>Send</button>
              <button className='btnCls' type='button' onClick={close}>Close</button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal onHide={close1}
       backdrop="static" keyboard={false}>
       <span className="close-icon-custom" onClick={close}>
               &times;
       </span>
        <Modal.Header>
          <Modal.Title>
            Forgot
            <a href="#!" className="font-weight-bold" style={{ color: '#151718' }}>
              <strong> Password </strong>
            </a>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Reset Password link has been sent successfully to your email id.
        </Modal.Body>
        <Modal.Footer>
          <div className='footer-grid'>
            <div className='modal__button-container'>
              <button className='btnCls' type="button" onClick={close1}>Close
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

  </div>
  );
};

export default Login;
